import React from 'react'
import { TimePicker as MuiTimePicker } from '@material-ui/pickers'
import { useController } from 'react-hook-form'

export const TimePicker = ({
  name,
  label,
  className,
  defaultValue = new Date(),
  control,
  helperTextStyle,
  disabled
}) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue
  })

  return (
    <MuiTimePicker
      name={name}
      label={label}
      value={field.value}
      inputRef={field.ref}
      onChange={field.onChange}
      onClose={() => field.onBlur()}
      helperText={error}
      error={invalid}
      ampm={false}
      disabled={disabled}
      InputProps={{
        classes: {
          input: className
        }
      }}
      InputLabelProps={{
        shrink: false,
        style: { fontSize: '15px' }
      }}
      FormHelperTextProps={{
        style: {
          ...helperTextStyle
        }
      }}
    />
  )
}
